import { sendMessageToClub } from '../../api/clubs';


const actions = {

  async sendMessageToClub({ commit }, payload) {
    try {
      const response = await sendMessageToClub(
        payload.purchaseId, 
        payload.userId, 
        payload.message
      );
      commit('SET_MESSAGE', response.data.message);
      return response.data;
    } catch (error) {
      console.error('An error occurred while sending the message to the club:', error);
      commit('SET_MESSAGE', 'Failed to Send Message to Club');
      return null;
    }
  }
};

export default {
    actions
};
